if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form');
            this.form.querySelector('[name=id]').disabled = false;
            
            // Wait for liquidAjaxCart to be available
            if (window.liquidAjaxCart) {
                this.init();
            } else {
                document.addEventListener('liquidAjaxCartInit', () => {
                    this.init();
                });
            }
        }

        init() {
            // Subscribe to cart state updates to handle loading states
            if (window.liquidAjaxCart && window.liquidAjaxCart.subscribeToCartStateUpdate) {
                window.liquidAjaxCart.subscribeToCartStateUpdate((cartState, isCartStateChanged) => {
                    this.updateLoadingState(cartState);
                });
            }

            // Subscribe to cart requests to handle errors
            if (window.liquidAjaxCart && window.liquidAjaxCart.subscribeToCartAjaxRequests) {
                window.liquidAjaxCart.subscribeToCartAjaxRequests((requestState, subscribeToResult) => {
                    // Only handle requests initiated by this form
                    if (requestState.info && requestState.info.initiator === this.form) {
                        subscribeToResult((resultState) => {
                            this.handleRequestResult(resultState);
                        });
                    }
                });
            }

            // Add error message container attribute for ajax-cart library
            const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
            if (errorWrapper && !errorWrapper.hasAttribute('data-ajax-cart-messages')) {
                errorWrapper.setAttribute('data-ajax-cart-messages', 'form');
            }
        }

        updateLoadingState(cartState) {
            const submitButton = this.querySelector('[type="submit"]');
            if (!submitButton) return;

            if (cartState && cartState.status && cartState.status.requestInProgress) {
                submitButton.setAttribute('aria-disabled', true);
                submitButton.classList.add('loading');
            } else {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
            }
        }

        handleRequestResult(resultState) {
            // Handle errors that might not be caught by ajax-cart's default error handling
            if (resultState.responseData && !resultState.responseData.ok) {
                let errorMessage = '';
                
                if (resultState.responseData.body) {
                    if (resultState.responseData.body.description) {
                        errorMessage = resultState.responseData.body.description;
                    } else if (resultState.responseData.body.message) {
                        errorMessage = resultState.responseData.body.message;
                    }
                }
                
                if (!errorMessage && resultState.fetchError) {
                    errorMessage = 'Unerwarteter Fehler, bitte versuchen Sie es später erneut.';
                }
                
                if (errorMessage) {
                    this.handleErrorMessage(errorMessage);
                }
            } else if (resultState.responseData && resultState.responseData.ok) {
                // Success - clear any error messages
                this.handleErrorMessage();
            }
        }

        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
            if (!this.errorMessage) return;

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}